import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-no-follow',
    templateUrl: './no-follow.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoNoFollowComponent {
}
